import { useContent } from "contexts/contentContext/contentContext.js";
import Button from "components/Elements/Button/Button";
import "./ErrorModals.scss";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import Image from "components/Elements/Image/Image";
import { useModal } from "contexts/modalContext/modalContext";

const NotSubscriberExtraStorage = () => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  return (
    <div className="extra-storage-not-availabe-modal">
      <div className="image">
        <Image name="purchases/present" ext="png" />
      </div>
      <div className="title">{getTextByKey("purchase-feature-only-subs")}</div>
      <div className="text">
        {getTextByKey("purchase-upgrade-account-text")}
      </div>
      <div className="actions">
        <LinkToNewTab page={"plans"} isNewTab={true}>
          <Button className="new-button">{getTextByKey("upgrade-plan")}</Button>
        </LinkToNewTab>
        <Button className="new-button" blank onClick={() => closeModal()}>
          {getTextByKey("cancel")}
        </Button>
      </div>
    </div>
  );
};

export default NotSubscriberExtraStorage;
